import type { InventorizationSyncPayload } from '@/features/sync/engine/inventorization-sync-payload';
import type { ValidationIssue } from '@/shared/capture/capture-session';

export const FIELD_SYNC_TRANSPORT_STATUSES = {
  accepted: 'accepted',
  conflict: 'conflict',
  partial: 'partial',
  rejected: 'rejected',
} as const;

export type FieldSyncTransportStatus =
  (typeof FIELD_SYNC_TRANSPORT_STATUSES)[keyof typeof FIELD_SYNC_TRANSPORT_STATUSES];

export interface FieldSyncTransportResult {
  errorCode?: string;
  remoteEntityIds?: {
    _id?: string;
    floorplanId?: string | number;
    id?: number;
    inventory_location_building_floorplan_id?: string | number;
    inventoryLocationBuildingFloorplanId?: string | number;
  };
  responseStatus?: number;
  status: FieldSyncTransportStatus;
  validationErrors?: ValidationIssue[];
}

export interface FieldSyncTransport {
  submitInventorization(payload: InventorizationSyncPayload): Promise<FieldSyncTransportResult>;
}

/** Thrown when a submission could not be attempted for a transient reason; the record stays retryable. */
export class FieldSyncTransportError extends Error {
  constructor(
    readonly errorCode: string,
    options?: ErrorOptions,
  ) {
    super(errorCode, options);
  }
}
